import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-man_lg",
  "use": "icon-man_lg-usage",
  "viewBox": "0 0 27 27",
  "content": "<symbol viewBox=\"0 0 27 27\" id=\"icon-man_lg\">\n  <path id=\"icon-man_lg_male\" class=\"cls-1\" d=\"M1826,1868v2h9.66l-8.79,9.19a9.059,9.059,0,1,0,1.36,1.47l8.77-9.17V1881h2v-13h-13Zm-5,25a7,7,0,1,1,7-7A7.008,7.008,0,0,1,1821,1893Z\" transform=\"translate(-1812 -1868)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol